import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.down('tablet')]: {
      padding: SPACES.m,
      paddingTop: SPACES.xxxxxl,

      width: 'calc(100vw - 40px)',
    },
    [theme.breakpoints.up('tablet')]: {
      padding: SPACES.xl,
      minHeight: 450,
    },
    [theme.breakpoints.between('tablet', 'laptop')]: {
      minWidth: 720,
    },
    [theme.breakpoints.up('laptop')]: {
      minWidth: 960,
    },
  },
}))
